var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content ht-100v pd-0"},[_vm._v("dynamic route comp here")])
}
var staticRenderFns = []

export { render, staticRenderFns }